import {Component, forwardRef, Inject, OnInit} from "@angular/core";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ClientService} from "../../../services/client.service";
import {DomSanitizer} from "@angular/platform-browser";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {PopupServices} from "../../../services/popup.services";
import {ExportPaieType, ModalResult} from "../../../model/common.model";
import {Enterprise} from "../../../model/Enterprise";

@Component({
  templateUrl: 'DlgCgiConnect.html'
})
export class DlgCgiConnect  implements OnInit {

  loading = false;

  enterprise : Enterprise;

  title = '';

  constructor(
              @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
              @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
              @Inject(forwardRef(() => NgbActiveModal)) private activeModal: NgbActiveModal,
              @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
              @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
              @Inject(forwardRef(() => SessionService)) private session: SessionService,
              @Inject(forwardRef(() => TranslateService)) private translate: TranslateService) {

  }



  ngOnInit() {


  }

  populate(enterprise: Enterprise){
    this.enterprise = enterprise;
    if (this.enterprise){
      let serviceName = 'N/A';
      if (ExportPaieType.DESJARDINS === this.enterprise.systemType || ExportPaieType.DESJARDINS_SPLIT === this.enterprise.systemType){
        serviceName = 'Employeur D';
      }else if (ExportPaieType.NETHRIS === this.enterprise.systemType || ExportPaieType.NETHRIS_SPLIT === this.enterprise.systemType){
        serviceName = 'Nethris';
      }
      this.title = this.translate.instant('ConnectToAPITitle',{service:serviceName});

    }

  }


  onClose() {
    this.activeModal.close(ModalResult.CANCEL);
  }




}
